export default __webpack_public_path__ + "static/media/image-dynamique.0367507e.svg";